<div class="card-header" id="machinesInstalleesHeader">
    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
        data-target="#machinesInstalleesCollapse" aria-expanded="true" aria-controls="machinesInstalleesCollapse">
        Rechercher une liste d'installations 'Installées'
    </button>
</div>

<div id="machinesInstalleesCollapse" class="panel-collapse collapse" aria-labelledby="machinesInstalleesHeader"
    data-parent="#accordionExtraction">
    <div class="card-body row">
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="wrapper shadowed">
            <h4>Liste des installations 'Installées'</h4>
            <br>
            <div class="paragraphe">
                <mat-form-field>
                    <input matInput [matDatepicker]="pickerstartDate" placeholder="Date de début"
                    formControlName="startDate">
                    <mat-datepicker-toggle matSuffix [for]="pickerstartDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerstartDate startView="month"></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <input matInput [matDatepicker]="pickerendDate" placeholder="Date de fin"
                    formControlName="endDate">
                    <mat-datepicker-toggle matSuffix [for]="pickerendDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerendDate startView="month"></mat-datepicker>
                </mat-form-field>

            </div>

            <button type="submit" class="btn btn-primary" style="margin-left: 40px;">Valider</button>

        </form>
        <br><br>

        <app-gmao-spinner *ngIf="loading"></app-gmao-spinner>


        <ng-container *ngIf="data">
            <div class="wrapper shadowed">

                <br />

                <h4>Résultats</h4>

                <app-export-button [data]="list"></app-export-button>

                <br />
                <mat-table [dataSource]="list">
                    <ng-container matColumnDef="numSerie">
                        <mat-header-cell *matHeaderCellDef> N° SÉRIE </mat-header-cell>
                        <mat-cell *matCellDef="let install"> {{install.numero_serie}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="nomInstallation">
                        <mat-header-cell *matHeaderCellDef> NOM </mat-header-cell>
                        <mat-cell *matCellDef="let install"> {{install.nom_installation}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="dateInstallation">
                        <mat-header-cell *matHeaderCellDef> DATE D'INSTALLATION </mat-header-cell>
                        <mat-cell *matCellDef="let install"> {{getNiceDate(install.date_installation)}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="dateMiseEnService">
                        <mat-header-cell *matHeaderCellDef> DATE DE MISE EN SERVICE</mat-header-cell>
                        <mat-cell *matCellDef="let install"> {{getNiceDate(install.date_MES)}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="dateArret">
                        <mat-header-cell *matHeaderCellDef> DATE D'ARRÊT</mat-header-cell>
                        <mat-cell *matCellDef="let install"> {{getNiceDate(install.date_arret)}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="raisonSocial">
                        <mat-header-cell *matHeaderCellDef> RAISON SOCIALE </mat-header-cell>
                        <mat-cell *matCellDef="let install"> {{install.raison_sociale}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="codeEBP">
                        <mat-header-cell *matHeaderCellDef> CODE EBP </mat-header-cell>
                        <mat-cell *matCellDef="let install"> {{install.code_EBP}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="codePostal">
                        <mat-header-cell *matHeaderCellDef> CP </mat-header-cell>
                        <mat-cell *matCellDef="let install"> {{install.code_postal}}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: ['numSerie', 'nomInstallation', 'dateInstallation', 'dateMiseEnService', 'dateArret','raisonSocial', 'codeEBP', 'codePostal'] ;"></mat-row>
                </mat-table>

            </div>
        </ng-container>
        <br />
    </div>
</div>